import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import Icons from '../../Elements/Icons/index.js';
import { Wrapper, Item } from './styled.js';
import { MarkerSelectValue } from './types.js';
export const MarkerSelect = forwardRef(function MarkerSelect({ value, onChange, disabled }, ref) {
    const handleOnClick = useCallbackRef((item) => {
        if (!disabled) {
            onChange(item === value ? undefined : item);
        }
    });
    return (_jsx(Wrapper, { ref: ref, children: Object.values(MarkerSelectValue).map((marker) => (_jsx(Item, { $isSelected: value === marker, $isDisabled: disabled, $marker: marker, onClick: () => handleOnClick(marker), "data-testid": `${marker}-marker`, "data-selected": value === marker, children: value === marker ? (_jsxs(_Fragment, { children: [_jsx(Icons.Checkmark, { size: 12, alt: true, dataTestId: 'checkmark-icon' }), _jsx(Icons.Close, { size: 12, alt: true, dataTestId: 'close-icon' })] })) : (_jsx(Icons.Plus, { size: 14, alt: true, dataTestId: 'plus-icon' })) }, marker))) }));
});
MarkerSelect.displayName = 'MarkerSelect';
